module.exports = __webpack_public_path__ + "static/media/PG-Logomark-Primary.998bc58b.svg";